import { Component, Input } from '@angular/core';
import { EditOrderInstructionsFlowTypes, EditOrderService, MenuOption } from '../../../services/edit-order.service';
import { NeighbourIconComponent } from './icons/neighbour-icon/neighbour-icon.component';
import { SafePlaceIconComponent } from './icons/safe-place-icon/safe-place-icon.component';
import { CourierNoteComponent } from './icons/courier-note/courier-note.component';

@Component({
  selector: 'common-delivery-instructions-menu',
  templateUrl: './delivery-instructions-menu.component.html',
  styleUrls: ['./delivery-instructions-menu.component.scss'],
})
export class DeliveryInstructionsMenuComponent {
  @Input() brandColor?: string;
  @Input() textColor?: string;
  menuOptions: MenuOption[] = [
    {
      iconComponent: NeighbourIconComponent,
      title: 'Leave with a neighbour',
      action: EditOrderInstructionsFlowTypes.Neighbour,
    },
    {
      iconComponent: SafePlaceIconComponent,
      title: 'Deliver to a safe place',
      action: EditOrderInstructionsFlowTypes.SafePlace,
    },
    {
      iconComponent: CourierNoteComponent,
      title: 'Leave a note for the courier',
      action: EditOrderInstructionsFlowTypes.CourierNote,
    },
  ];

  constructor(private editOrderService: EditOrderService) {}

  onSelect(option: MenuOption) {
    this.editOrderService.onChooseDeliveryInstructionsOption(option, option.action as EditOrderInstructionsFlowTypes);
  }
}
